import { memo, type ReactNode } from "react";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import { Panel } from "../../surfaces/Panel";

const ItalicText = styled(Typography)({ fontStyle: "italic" });

export interface AIQuoteProps {
  children: ReactNode;
  /** "default" uses body1; "small" uses body2 for compact contexts. */
  size?: "default" | "small";
}

/** AI-generated excerpt displayed as an italic accent-tinted quote — matches the Evidence panel
 *  in FieldReviewPanel. Use for primary findings, LLM-extracted summaries, and similar verbatim
 *  outputs where the AI origin should be visually distinct. */
export const AIQuote = memo(function AIQuote({ children, size = "default" }: AIQuoteProps) {
  return (
    <Panel tone="accent" pad="sm">
      <ItalicText variant={size === "small" ? "body2" : "body1"}>
        &ldquo;{children}&rdquo;
      </ItalicText>
    </Panel>
  );
});
